import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { URLS, Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { Groups, Props as WidgetProps } from './Groups';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import EmptyState from '../../EmptyState';
import GroupsConfigPopover from './GroupsConfigPopover';

import s from './Groups.scss';

class GroupsBox extends React.Component<
  WidgetProps &
    WidgetBoxProps &
    WithTranslation & {
      totalCount?: number;
      isOwner: boolean;
      isEmpty: boolean;
    }
> {
  render() {
    const {
      isHeaderStickyOnMobile,
      hasMore,
      totalCount,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      isEmpty,
      section,
      zone,
      ...props
    } = this.props;
    const seeAllFragment =
      props.type === 'member' ? 'group_list_members' : 'group_list_admins';

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={props.t!(`widgets.groups_${props.type}.header`)}
        count={totalCount}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        seeAllUrl={Url.userLink(
          props.profileOwnerUser.username,
          `${USER_PROFILE_SECTION_PATHS.ABOUT}#${seeAllFragment}`
        )}
        hasMore={hasMore}
        moduleId={props.moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        widgetMenuRenderer={close => (
          <GroupsConfigPopover moduleId={props.moduleId} onClose={close} />
        )}
        isEmpty={isEmpty}
        emptyView={
          props.isOwner ? (
            <EmptyState
              view="small"
              className={classnames(s['empty-state'], s[props.type])}
              title={props.t!(`widgets.groups_${props.type}.empty.title.owner`)}
              subtitle={props.t!(
                `widgets.groups_${props.type}.empty.subtitle.owner`
              )}
              buttonLabel={props.t!(
                `widgets.groups_${props.type}.empty.CTALabel.owner`
              )}
              withButton={true}
              onButtonClick={this.navigateToBrowseGroups}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!(
                `widgets.groups_${props.type}.empty.title.visitor`,
                {
                  username: props.profileOwnerUser.username,
                }
              )}
              subtitle={props.t!(
                `widgets.groups_${props.type}.empty.subtitle.visitor`,
                {
                  username: props.profileOwnerUser.username,
                }
              )}
            />
          )
        }
      >
        <Groups {...props} />
      </WidgetBox>
    );
  }

  navigateToBrowseGroups() {
    window.location.replace(URLS.GROUPS);
  }
}

export default withTranslation()(GroupsBox) as React.ComponentType<{}>;
